module.exports = __webpack_public_path__ + "img/conference9.8768d9d9.jpg";